// extracted by mini-css-extract-plugin
export var label = "_hb-2";
export var slideContainer = "_hb-0";
export var slider = "_hb-1";